import React from 'react';
import { Navigate } from 'react-router-dom';
import useSubscriptionStore from '../../stores/subscriptionStore';

/**
 * Route-level guard for feature-gated pages.
 * Redirects to /subscription if the user lacks the required feature.
 * This is a defense-in-depth layer — backend still enforces access.
 */
const FeatureProtectedRoute = ({ feature, children, redirectTo = '/subscription' }) => {
  const { hasFeature, initialized } = useSubscriptionStore();

  // Don't redirect before subscription data is loaded
  if (!initialized) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600"></div>
      </div>
    );
  }

  if (feature && !hasFeature(feature)) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default FeatureProtectedRoute;
